import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useTranslation } from "@i18n";
import TrackingFinanceDetailsComponent from "@/pages/tracking/components/TrackingFinanceComponents/TrackingFinanceDetailsComponent/TrackingFinanceDetailsComponent";
import { useParams } from "react-router-dom";
import Loader from "@componentsShared/Loader/Loader";
import { api__getAllFinanceOfferedDoc, api__getTrackingFinanceDetails } from "@/apis/orderTracking/api__getOrderTrackingList";
import useApi from "@hooks/useApi";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { getCurrentStep } from "@/pages/tracking/utls";
var TrackingFinanceDetails = function TrackingFinanceDetails() {
  var _useTranslation = useTranslation(["web_tracking_finance"]),
    t = _useTranslation.t;
  var _useParams = useParams(),
    orderId = _useParams.orderId;
  var _useSession = useSession(),
    user = _useSession.user;
  var _useState = useState(0),
    refreshKey = _useState[0],
    setRefreshKey = _useState[1];
  //----------------------------------------------------------------------
  var _useApi = useApi([orderId, refreshKey], function () {
      return api__getTrackingFinanceDetails(orderId);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    details = _useApi2[2];
  var _useApi3 = useApi([orderId], function () {
      return api__getAllFinanceOfferedDoc(orderId);
    }),
    _useApi4 = _slicedToArray(_useApi3, 3),
    loading2 = _useApi4[0],
    error2 = _useApi4[1],
    allOfferedDoc = _useApi4[2];
  useEffect(function () {
    if (!__IS_CSR__) return;
    var isDirectLink = !document.referrer || !document.referrer.includes(window.location.hostname);
    if (isDirectLink) {
      trackEvents("order_tracking_entry", {
        referral_location: "direct_link",
        platform: getPlatformInfo()
      });
    }
  }, []);
  useEffect(function () {
    var _details$payment_type;
    if (!details) return;
    var currentStep = getCurrentStep(details);
    trackEvents("order_tracking_viewed", {
      order_id: details.id,
      order_type: (_details$payment_type = details.payment_type) !== null && _details$payment_type !== void 0 ? _details$payment_type : "financing",
      order_step: currentStep ? currentStep.title : null,
      has_warranty: details.warrantyV2 !== null ? "yes" : "no",
      platform: "web"
    });
  }, [details === null || details === void 0 ? void 0 : details.id]);
  if (loading || loading2) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    mobileHasTitle: t("track_finance_order", {
      ns: "web_tracking_finance"
    }),
    hideOrangeHeadBtn: true,
    mobileHasBack: true,
    mobileNoLogo: true,
    headHideLinks: true,
    hideFooter: true,
    hideHeaderOnmobile: true,
    hideFooterWithoutAuthMsg: true
  }, /*#__PURE__*/React.createElement(TrackingFinanceDetailsComponent, {
    details: details,
    allOfferedDoc: allOfferedDoc,
    onRefreshOrder: function onRefreshOrder() {
      return setRefreshKey(function (k) {
        return k + 1;
      });
    }
  }));
};
export default TrackingFinanceDetails;